import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ImpersonationBroker, ITemplateCard } from '../../viewmodels/AppViewModels';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

export const EMAIL_SEARCH_TEMPLATES_QUERY_KEY = 'emailSearchTemplates';

export const useEmailSearchTemplates = ({
	industry,
	query,
	excludeExpired = true,
	sortBy = 'lastModifiedDate',
	enabled,
	impersonationContext,
	meta,
}: {
	query: string;
	industry: Api.Industry;
	enabled?: boolean;
	excludeExpired?: boolean;
	sortBy?: string;
	impersonationContext?: Api.IImpersonationContext;
	meta?: LevStandardQueryMeta;
}) => {
	const userSession = useUserSession();
	const search = query.trim();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<ITemplateCard[]>(
				ImpersonationBroker.composeApiUrl({
					queryParams: {
						excludeExpired,
						search,
						sortBy,
					},
					urlPath: `template/${encodeURIComponent(industry)}/filter`,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [EMAIL_SEARCH_TEMPLATES_QUERY_KEY, industry, excludeExpired, search, sortBy, impersonationContext],
		meta,
	});
};

export const invalidateEmailSearchTemplates = () => {
	reactQueryClient.invalidateQueries({ queryKey: [EMAIL_SEARCH_TEMPLATES_QUERY_KEY] });
};
